import { camelCase } from 'lodash-es';

// calls an object of reducers based on action type or returns current state
export default (state, action, constants, reducers) => {
  const { type } = action;

  // generate a map of constants to reducers to call
  const reducerObject = Object.keys(constants).reduce((acc, curr) => {
    const reduction = reducers[camelCase(`reduce${constants[curr]}`)];

    return reduction ? { ...acc, [constants[curr]]: reduction } : acc;
  }, {});

  // if reducer exists for a given action type then call it passing current state and action
  // otherwise return the current state
  return reducerObject[type] ? reducerObject[type](state, action) : state;
};
